import utils from '@src/common/utils'
import i18n from '@src/common/lib/i18n'
import {
  Dic
} from '@src/common/utils'
const carTableOption = function () {
  return {
    view: '车辆授权详情',
    page: true,
    selection: true,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: '700px',
    viewDialogWidth: '700px',
    viewDialogHeight: 350,
    viewFormSlot: true,
    emptyText: '暂无数据',
    column: [
      // {
      //   label: '授权编号',
      //   prop: 'authCode',
      //   search: true,
      //   addDisplay: false,
      //   editDisplay: false,
      //   viewDisplay: false,
      //   overHidden: true,
      //   span: 12
      // }, 
      {
        label: '名称',
        prop: 'name',
        search: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        overHidden: false,
        viewslot: true,
        span: 12
      },
      {
        label: '电话',
        prop: 'phone',
        editDisabled: false,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: false,
        overHidden: true,
        align: 'center',
        minRows: 4,
        maxlength: 50,
        span: 12,
      },
      {
        label: '车牌号',
        prop: 'plateCode',
        type: 'text',
        value: '',
        search: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        span: 12
      },
      {
        label: '授权状态',
        prop: 'authStatus',
        type: 'select',
        search: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        span: 12,
        dicData: [{
            label: '失效',
            value: '2'
          },
          {
            label: '已授权',
            value: '1'
          }
        ],
        viewFormatter: (row, value) => {
          if (Number(value) === 1) {
            return '已授权'
          } else if (Number(value) === 2) {
            return '失效'
          }
          return '';
        },
        formatter: (row, value) => {
          if (Number(value) === 1) {
            return '已授权'
          } else if (Number(value) === 2) {
            return '失效'
          }
          return '';
        },
      },
      {
        label: '授权渠道',
        prop: 'authChannel',
        search: true,
        type:'select',
        searchSlot: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        span: 12,
        align: 'center',
        dicData: Dic.find('SENU104001'),
        viewFormatter: (row, value) => {
          if (value) {
            return Dic.findByValue('SENU104001', Number(value))
          }
          return ''
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue('SENU104001', value) : ''
        },
      },
      {
        label: '授权人',
        prop: 'creatorName',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        overHidden: true,
        search: false,
      },
      {
        label: '授权时间',
        prop: 'createTime',
        value: '',
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        align: 'right',
        type: 'datetime',
        columnWidth: '150px',
        span: 12,
        rules: [{
          required: true,
          message: "请选择授权开始时间",
          trigger: "blur",
        }, ],
        formatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        }
      },
      {
        label: '道闸通行区域',
        prop: 'thirdDeviceName',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        overHidden: true,
        search: false,
      },
      {
        label: '通行生效时间',
        prop: 'effectiveTime',
        search: false,
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        align: 'right',
        type: 'datetime',
        columnWidth: '150px',
        span: 12,
        rules: [{
          required: true,
          message: "请选择通行生效时间",
          trigger: "blur",
        }, ],
        formatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        }
      },
      {
        label: '通行失效时间',
        prop: 'expirationTime',
        value: '',
        search: false,
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        align: 'right',
        type: 'datetime',
        columnWidth: '150px',
        span: 12,
        rules: [{
          required: true,
          message: "请选择通行失效时间",
          trigger: "blur",
        }, ],
        formatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        }
      },
    ]
  }
}
export default carTableOption